/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespEditorialModule_componentModule = {
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly linkData: {
            readonly path: string | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"HpRespEditorialModuleItem_item">;
    } | null> | null;
    readonly " $refType": "HpRespEditorialModule_componentModule";
};
export type HpRespEditorialModule_componentModule$data = HpRespEditorialModule_componentModule;
export type HpRespEditorialModule_componentModule$key = {
    readonly " $data"?: HpRespEditorialModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespEditorialModule_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespEditorialModule_componentModule",
  "type": "EditorialModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "EditorialItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespEditorialModuleItem_item",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ff8d84ae71621c68c279c815d0cb9d9c';
export default node;
